import React from 'react';
import { Link } from 'react-router-dom';
import FAQ from '../../components/FAQ/FAQ';
import bannerImage from '../../assets/images/homePage-banner.png';
import appStoreIcon from '../../assets/images/appstore-icon.svg';
import playStoreIcon from '../../assets/images/playstore-icon.svg';
import WhyPhoneVue from '../WhyPhoneVue/WhyPhoneVue';
import HowPhoneVue from '../HowPhoneVue/HowPhoneVue';
import PhoneVueFunctions from '../PhoneVueFunctions/PhoneVueFunctions';
import PhoneVueFeatures from '../PhoneVueFeatures/PhoneVueFeatures';
import aboutUsImage from '../../assets/images/aboutUs.png';
import './Home.css';

const Home = () => {
  return (
    <div className="home-page">
      <section className="hero-banner-section">
        <div className="banner-container">
          <div className="banner-content">
            <p className="banner-label">Smartphone Diagnostic App</p>
            <h1 className="banner-headline">
              Would you like to check your <span className="highlight-blue">Smartphone Health?</span>
            </h1>
            <p className="banner-description">
              Smart diagnostics for smarter devices. Track 24 system checks and battery performance in one scan.
            </p>
            <div className="app-store-badges">
              <a 
                href="https://apps.apple.com/in/app/phonevue/id6499223089" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="store-badge"
                aria-label="Download on the App Store"
              >
                <img src={appStoreIcon} alt="Download on the App Store" />
              </a>
              <a 
                href="https://play.google.com/store/apps/details?id=com.phonevue.android&hl=en_IN" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="store-badge"
                aria-label="GET IT ON Google Play"
              >
                <img src={playStoreIcon} alt="GET IT ON Google Play" />
              </a>
            </div>
          </div>
          <div className="banner-image-container">
            <img src={bannerImage} alt="PhoneVue Diagnostic App Screenshots" className="banner-image" />
          </div>
        </div>
      </section>

      <section className="about-us-section">
        <div className="about-us-container">
          <div className="about-us-image-container">
            <img src={aboutUsImage} alt="PhoneVue Smart Diagnostics App Interface" className="about-us-image" />
          </div>
          <div className="about-us-content">
            <p className="about-us-label">About Us</p>
            <h2 className="about-us-heading">What is PhoneVue?</h2>
            <p className="about-us-description">
              PhoneVue is a smartphone failure prediction diagnosis app that helps you check your phone's working condition by yourself. It allows you to diagnose small or major hardware issues through up to 24 diagnostic functions, covering essential smartphone components.
            </p>
            <h3 className="about-us-subheading">What PhoneVue Checks</h3>
            <ul className="about-us-checklist">
              <li>Sensor status</li>
              <li>Communication status</li>
              <li>Screen and display performance</li>
              <li>Buttons and power supply</li>
              <li>SIM status</li>
              <li>Camera, microphone, and speaker</li>
            </ul>
            <div className="about-us-features">
              <div className="feature-column">
                <h4 className="feature-title">Battery Health Diagnosis</h4>
                <p className="feature-description">
                  In addition to hardware checks, PhoneVue assists in diagnosing battery deterioration and provides battery degradation prediction for up to two years ahead. You can easily check your smartphone's battery health with a single touch.
                </p>
              </div>
              <div className="feature-column">
                <h4 className="feature-title">On-the-Spot Diagnosis</h4>
                <p className="feature-description">
                  PhoneVue enables you to identify failure signs instantly — without visiting a carrier shop or repair center. You can manage smartphone diagnostics anytime, without appointments, waiting time, or service visits.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="why-phonevue-link-container">
        <WhyPhoneVue />
      </div>

      <div className="how-phonevue-link-container">
        <HowPhoneVue />
      </div>

      <div className="phonevue-functions-link-container">
        <PhoneVueFunctions />
      </div>

      <div className="phonevue-features-link-container">
        <PhoneVueFeatures />
      </div>

      <section className="faq-section">
        <FAQ />
      </section>
    </div>
  );
};

export default Home;

